<template>
    <div>
        <app-header :module-navigation="navigation" module-name="SéréVita"></app-header>
        <main id="page-main" class="with-tabs">
            <router-view></router-view>
        </main>
    </div>
</template>
<script>

    export default {
        name: 'Company',
        data () {
            return {
                navigation: [
                    {
                        route: 'serevita-dashboard',
                        label: 'Dashboard',
                        acl: null
                    },
                    {
                        route: 'contract',
                        label: 'Contrats',
                        acl: 'weeboxserevita.contract.view'
                    },
                    {
                        route: 'protractor',
                        label: 'Apporteur d\'affaire',
                        acl: 'weeboxserevita.protractor.view'
                    },
                    {
                        route: 'protractor-link',
                        label: 'Affaires rapportées',
                        acl: 'weeboxserevita.protractorlink.view'
                    },
                    {
                        route: 'table',
                        label: 'Liste de prix',
                        acl: 'weeboxserevita.table.view'
                    }
                ]
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/serevita/Index.vue